export default __webpack_public_path__ + "static/media/file.7afbb506.jpeg";